import '../styles/pagination.css'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

export default function Pagination( { totalPages, currentPage, handlePageChange} ) {
  return (
    <div className="pagination">
        <button className="arrow" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
          <LeftOutlined></LeftOutlined>
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button key={index} onClick={() => handlePageChange(index)} disabled={index === currentPage}>
            {index + 1}
          </button>
        ))}
        <button className="arrow" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage + 1 === totalPages}>
          <RightOutlined></RightOutlined>
        </button>
      </div>
  )
}